'use client'
import { Link } from '@/i18n/routing'
import classNames from 'classnames'
import { ComponentProps, FC } from 'react'

type NavLinkProps = {
  href: ComponentProps<typeof Link>['href']
  title: string
  isActive?: boolean
  isHovered?: boolean
}

// Gleiche Masse wie der Mega-Menue-Ausloeser in NavBar, damit der gleitende
// Highlight-Hintergrund zwischen Links und Ausloesern nicht in der Hoehe springt
export const navItemClassName = 'py-[18px] px-3.5 xl:px-5 rounded-[25px] m-0 leading-[11px] font-[500] whitespace-nowrap transition-colors duration-150'

const NavLink: FC<NavLinkProps> = ({ href, title, isActive = false }) => {
  return (
    <Link
      href={href}
      data-nav-link={typeof href === 'string' ? href : href.pathname}
      className={classNames(navItemClassName, isActive ? 'text-selected-nav-tag' : 'text-white bg-transparent border-none', 'relative z-10')}
    >
      {title}
    </Link>
  )
}

export default NavLink
